import { snordeluxeAssets } from '../snordeluxeAssets';
import { updateStats } from './stats';
import { saveUserData } from '../auth/kindeClient';
import { playSound } from '../assets';
import { hideGameplayOverlay } from '../gameplay/game';
import { getUser } from './views';
import { updateInventoryDisplay } from './inventory';
import { sendEventMessage } from './chat';
import { hasDefeated } from './defeatedSnordeluxes';

const shopPage = document.getElementById('shopPage');
const chatContainer = document.getElementById('chat-container');

function getUnlockRequirement(user, name) {
    if (hasDefeated(user, name)) return 'Unlocked by defeating one in battle.';
    return `Defeat ${name} in battle to unlock it.`;
}

function formatCost(snordeluxe) {
    const coinLabel = snordeluxe.coins === 1 ? 'Coin' : 'Coins';
    const gemLabel = snordeluxe.gems === 1 ? 'Gem' : 'Gems';
    return `${snordeluxe.coins} ${coinLabel} and ${snordeluxe.gems} ${gemLabel}`;
}

function showShopPage() {
    console.log("Shop button clicked.");
    playSound('swoosh');
    hideGameplayOverlay();
    
    // Clear existing content first
    shopPage.innerHTML = `
        <div id="shopContent">
            <button id="closeShopButton" class="interactive-button">X</button>
            <div id="itemsContainer" class="shop-grid"></div>
        </div>
    `;
    
    // Set display and classes AFTER creating the content
    shopPage.style.display = 'flex';
    shopPage.classList.add('visible');
    shopPage.classList.add('active');
    document.body.classList.add('shop-open');

    if (chatContainer) {
        chatContainer.style.display = 'none';
    }
    
    // Add event listener AFTER creating the button
    const closeButton = document.getElementById('closeShopButton');
    if (closeButton) {
        closeButton.addEventListener('click', (e) => {
            e.preventDefault(); // Prevent any default behavior
            e.stopPropagation(); // Prevent event bubbling
            console.log('Close button clicked'); // Debug log
            playSound('click');
            hideShopPage();
        });
    } else {
        console.error('Close button not found!'); // Debug log
    }
    
    const itemsContainer = document.getElementById('itemsContainer');
    
    const user = getUser();
    const roster = Object.keys(snordeluxeAssets)
        .filter(name => snordeluxeAssets[name].level === 1);

    roster.forEach(name => {
        const snordeluxe = snordeluxeAssets[name];
        const unlocked = hasDefeated(user, name);
        const itemDiv = document.createElement('div');
        itemDiv.classList.add('snordeluxe-item', unlocked ? 'is-unlocked' : 'is-locked');
        itemDiv.innerHTML = `
            <img src="${snordeluxe.image}" alt="${name} Snordeluxe" />
            <p class="shop-name">${name}</p>
            ${unlocked ? '' : '<p class="shop-lock-badge">Locked</p>'}
            <p class="shop-unlock-hint">${getUnlockRequirement(user, name)}</p>
            <p class="shop-cost">Cost: ${formatCost(snordeluxe)}</p>
        `;

        if (unlocked) {
            const purchaseButton = document.createElement('button');
            purchaseButton.textContent = 'Purchase';
            purchaseButton.classList.add('interactive-button');
            purchaseButton.addEventListener('click', () => {
                playSound('click');
                purchaseSnordeluxe(name);
            });
            itemDiv.appendChild(purchaseButton);
        } else {
            const lockedButton = document.createElement('button');
            lockedButton.textContent = 'Locked';
            lockedButton.classList.add('shop-locked-button');
            lockedButton.disabled = true;
            lockedButton.setAttribute('aria-label', `${name} is locked. ${getUnlockRequirement(user, name)}`);
            itemDiv.appendChild(lockedButton);
        }

        itemsContainer.appendChild(itemDiv);
    });
}

function hideShopPage() {
    console.log('Hiding shop page'); // Debug log
    shopPage.style.display = 'none';
    shopPage.classList.remove('visible');
    shopPage.classList.remove('active');
    document.body.classList.remove('shop-open');

    if (chatContainer) {
        chatContainer.style.display = 'flex';
    }
}

async function purchaseSnordeluxe(name) {
    console.log(`Attempting to purchase ${name}`);
    const snordeluxe = snordeluxeAssets[name];
    const user = getUser(); // Get the current user state

    if (user.coins >= snordeluxe.coins && user.gems >= snordeluxe.gems) {
        user.coins -= snordeluxe.coins;
        user.gems -= snordeluxe.gems;
        addToInventory(name);
        saveUserData();
        console.log(`Purchased ${name}!`);
        displayModal('success', `Purchased ${name}!`);
        playSound('chime');
        const purchaseMessage = `${user.username} purchased a new Snordeluxe: ${name}!`;
        await sendEventMessage(user.username, purchaseMessage, 'store');
        updateStats(user.mana, user.coins, user.gems);
    } else {
        console.log('Not enough currency to purchase this Snordeluxe.');
        displayModal('warning', 'Not enough currency to purchase this Snordeluxe.');
    }
}

function displayModal(type, message) {
    console.log(`Displaying modal: ${type} - ${message}`);
    const modal = document.createElement('div');
    modal.classList.add('modal-overlay', type, 'show');
    modal.innerHTML = `
        <div class="modal-content">
            <span class="close-button">&times;</span>
            <p>${message}</p>
        </div>
    `;
    document.body.appendChild(modal);

    modal.querySelector('.close-button').addEventListener('click', function() {
        modal.remove();
    });

    modal.addEventListener('click', function(event) {
        if (event.target === modal) {
            modal.remove();
        }
    });

    setTimeout(() => {
        modal.remove();
    }, 5000);
}

function addToInventory(name) {
    console.log(`Adding ${name} to inventory`);
    const snordeluxe = snordeluxeAssets[name];
    const user = getUser(); // Get the current user state
    const newSnordeluxe = {
        name: name,
        trainedAttacks: ['basic'] // Automatically train the basic attack
    };
    user.inventory.push(newSnordeluxe);
    updateInventoryDisplay();
}

export { showShopPage, hideShopPage, purchaseSnordeluxe, addToInventory, getUnlockRequirement };
